import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, IDisplayJoinField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {TPMEventSpendSearch} from "../PA.UIM.TPM/TPMEventSpendSearch";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {Status_Type_PendingApproval, Status_Type_Approved} from "../PA.TPM.Core/TPM.Constants";


const PaymentSearch: ISearch = {
    searchName: "Find Payment ",
    renderOptions: {ui5ResourceId: "PaymentSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
};


const vUI_Payment_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PMT_ID:         {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Payment WB Id', columnResourceName: 'colId',              alignment: HorizAlignment.Center}, domainOptions: {}},
    WB_SALESORG_ID:    {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Sales Org Id',  columnResourceName: 'colSalesOrgId',       alignment: HorizAlignment.Center}, domainOptions: {}},
    WB_STATUS_ID:      {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Status Id',     columnResourceName: 'colStatusId',        alignment: HorizAlignment.Center}, domainOptions: {}},
    PAYMENT_ID:        {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Payment Id',    columnResourceName: 'colPaymentId',       alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    PAYMENT_NAME:      {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Name',          columnResourceName: 'colName',            alignment: HorizAlignment.Left},   domainOptions: {maxLength: 256}},
    PAYMENT_TYPE_NAME: {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Type',          columnResourceName: 'colTypeName',        alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    PAYMENT_DT:        {type: SearchProviderFieldType.sapdate, renderOptions: {columnName: 'Pmt Date',      columnResourceName: 'colPaymentDt',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 10}},
    PAYMENT_AMT:       {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Payment Amt',   columnResourceName: 'colPmtAmt',          alignment: HorizAlignment.Right},  domainOptions: {}},
    CURRENCY:          {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Currency',      columnResourceName: 'colPaymentCurrency', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 10}},
    CUSTOMER:          {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Customer',      columnResourceName: 'colCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    CUSTOMER_ID:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Customer Id',   columnResourceName: 'colCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    FUNDING_CUSTOMER:  {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Funding Customer',      columnResourceName: 'colFundingCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    PLANNING_CUSTOMER: {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Planning Customer',      columnResourceName: 'colPlanningCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    WB_CUST_ID_PLANNING: {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Planning Customer Id', columnResourceName: 'colPlanningCustomerId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PAYTO_CUSTOMER_NAME: {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Pay To Customer',      columnResourceName: 'colPayToCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    WB_CUST_ID_PAYTO:  {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Pay To Customer Id', columnResourceName: 'colPayToCustomerId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PERIOD_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Period',        columnResourceName: 'colPeriodName',    alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    STATUS_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Status',        columnResourceName: 'colStatusName',    alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    STATUS_TYPE:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Status Type',   columnResourceName: 'colStatusType',    alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    CREATED_BY:        {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Created By',    columnResourceName: 'colCreatedBy',     alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "pendingApproval", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    APPROVED_DTTS:     {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Approved Dt',   columnResourceName: 'colStatusName',    alignment: HorizAlignment.Left},   domainOptions: {}},
    CHECK_NUMBER:      {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Check #',       columnResourceName: 'colCheckNum',      alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    PAYMENT_ID_REF:    {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Payment Ref',   columnResourceName: 'colPaymentRefId',  alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
    PAYMENT_ID_COR:    {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Payment Cor',   columnResourceName: 'colPaymentCorId',  alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

function addPaymentAuthorizationFilter(findRequest: ISearchRequest): Promise<void> {
    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
    // Globe Sales Org scope applies regardless of role -- same rule as Events/Plans -- so it
    // runs before the VIEW_ALL short-circuit below, which only bypasses customer-role scoping.
    SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')
    if (usrContext.hasRoleId('VIEW_ALL')) {
        return Promise.resolve()
    }
    SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
    return SearchUtils.addUserGroupCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
}

const PaymentSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_PMT_ID',
        id_ui: 'PAYMENT_ID',
        name:  'PAYMENT_NAME'
    },


    searchProviderFields: vUI_Payment_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Payment_Search',
                this.searchProviderFields,
                [])

            addPaymentAuthorizationFilter(findRequest)
                .then(() => PASearch.findByRequest(findRequest))
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Payment_Search',
                this.searchProviderFields,
                [fieldName])

            addPaymentAuthorizationFilter(findRequest)
                .then(() => PASearch.findByRequest(findRequest))
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }


};


const PaymentSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "PaymentSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',               searchProviderFieldId: 'PAYMENT_ID',         renderOptions: {}},
        {profileFilterName: 'Name',             searchProviderFieldId: 'PAYMENT_NAME',      renderOptions: {}},
        {profileFilterName: 'Planning Customer', searchProviderFieldId: 'PLANNING_CUSTOMER', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Funding Customer', searchProviderFieldId: 'FUNDING_CUSTOMER', renderOptions: {}, bMultiSelect: true}, 
        {profileFilterName: 'Pay To Customer',   searchProviderFieldId: 'PAYTO_CUSTOMER_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Status',   searchProviderFieldId: 'STATUS_NAME',       renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Type',     searchProviderFieldId: 'PAYMENT_TYPE_NAME', renderOptions: {}, bMultiSelect: true},
    ],
    profileDisplayFields: [
        'CUSTOMER', 'PLANNING_CUSTOMER', 'FUNDING_CUSTOMER', 'PAYTO_CUSTOMER_NAME', 'PAYMENT_DT', 'PAYMENT_TYPE_NAME', 'PAYMENT_ID', 'PAYMENT_NAME', 'STATUS_NAME', 'PAYMENT_AMT','CURRENCY','CHECK_NUMBER','PAYMENT_ID_REF','PAYMENT_ID_COR',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: PaymentSearchProviderBasic,

    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

PaymentSearch.searchProfiles.push(PaymentSearchProfileByName)

// Restricts a payment search request to PendingApproval payments the current user is actually
// authorized to move to an Approved-type status, per the payment's own workflow transition config
// (WB_STATUSR "User Role" per Start/Next Status, see the PA-Workflow Transitions admin screen) --
// rather than a single hardcoded role, since different payment types/workflows can require
// different approver roles for the same PendingApproval -> Approved move.
function addPendingApprovalFilter(findRequest: ISearchRequest): Promise<void> {
    SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')

    findRequest.where = _.isEmpty(findRequest.where)
        ? {STATUS_TYPE: Status_Type_PendingApproval}
        : {and: [{STATUS_TYPE: Status_Type_PendingApproval}, findRequest.where]}

    let approvalRolesRequest = SearchUtils.makeSearchRequest(
        {where: {STATUS_TYPE_CURRENT: Status_Type_PendingApproval, STATUS_TYPE_NEXT: Status_Type_Approved}},
        'vUI_Payment_ApprovalRoles',
        {WB_STATUS_ID: {type: 'number'}, WB_DOMITEM_ID: {type: 'number'}, STATUS_TYPE_CURRENT: {type: 'string'}, STATUS_TYPE_NEXT: {type: 'string'}}, [])

    return PASearch.findByRequest(approvalRolesRequest)
        .then((arrApprovalRoles: {WB_STATUS_ID: number, WB_DOMITEM_ID: number, WORKFLOW_USAGE: string}[]) => {
            let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let dctRoleIdByWbDomItemId: { [wbDomItemId: number]: string } = {}
            _.forEach(usrContext?.Roles, (aRole) => {
                dctRoleIdByWbDomItemId[aRole.cif.WB_DOMITEM_ID] = aRole.cif.DOMAIN_ITEM_ID
            })

            // Only the transitions whose required role the current user holds anywhere matter --
            // group their statuses by that role so we can resolve the customer scoping per role.
            let dctStatusIdsByRole: { [roleId: string]: number[] } = {}
            _.forEach(arrApprovalRoles, (aRow) => {
                let roleId = dctRoleIdByWbDomItemId[aRow.WB_DOMITEM_ID]
                if (!roleId) { return }
                dctStatusIdsByRole[roleId] = dctStatusIdsByRole[roleId] || []
                dctStatusIdsByRole[roleId].push(aRow.WB_STATUS_ID)
            })

            let arrMyCustIds = _.map(usrContext?.Customers, (aCust) => aCust.cif.WB_CUST_ID)

            return Promise.all(_.map(_.keys(dctStatusIdsByRole), (roleId: string) => {
                return Promise.resolve()
                    .then(() => {
                        let arrMyCustomerIds = _.filter(arrMyCustIds, (custId: number) =>
                            usrContext && usrContext.hasRoleId(roleId, custId))
                        return {statusIds: dctStatusIdsByRole[roleId], customerIds: arrMyCustomerIds}
                    })
            }))
        })
        .then((arrRoleScopes: { statusIds: number[], customerIds: number[] }[]) => {
            let arrClauses = _.filter(arrRoleScopes, (aScope) => !_.isEmpty(aScope.customerIds))
                .map((aScope) => ({
                    and: [
                        {WB_STATUS_ID: {inq: aScope.statusIds}},
                        {WB_CUST_ID_PLANNING: {inq: aScope.customerIds}}
                    ]
                }))

            let approverWhere = _.isEmpty(arrClauses)
                ? {WB_CUST_ID_PLANNING: {inq: [-999]}}
                : {or: arrClauses}

            findRequest.where = {and: [approverWhere, findRequest.where]}
        })
        .then(() => SearchUtils.addUserGroupCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING'))
}

const PaymentSearchProviderPendingApproval: ISearchProvider = {

    keyFields: {
        id:    'WB_PMT_ID',
        id_ui: 'PAYMENT_ID',
        name:  'PAYMENT_NAME'
    },

    searchProviderFields: vUI_Payment_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Payment_Search',
                this.searchProviderFields,
                [])

            addPendingApprovalFilter(findRequest)
                .then(() => PASearch.findByRequest(findRequest))
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Payment_Search',
                this.searchProviderFields,
                [fieldName])

            addPendingApprovalFilter(findRequest)
                .then(() => PASearch.findByRequest(findRequest))
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

};

const PaymentSearchProfilePendingApproval: ISearchProfile = {
    profileId: "pendingApproval",
    profileName: "Pending My Approval",
    renderOptions: {ui5ResourceId: "PaymentSearchProfilePendingApproval"},

    profileFilter: [
        {profileFilterName: 'Customer',    searchProviderFieldId: 'CUSTOMER',          renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Created By',  searchProviderFieldId: 'CREATED_BY',        renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Type',        searchProviderFieldId: 'PAYMENT_TYPE_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Id',          searchProviderFieldId: 'PAYMENT_ID',        renderOptions: {}},
        {profileFilterName: 'Submitted Date', searchProviderFieldId: 'CREATED_DTTS',   renderOptions: {}},
    ],
    profileDisplayFields: [
        'CUSTOMER', {columnTitle: "Submitted Date", seperator: "", fields: ['CREATED_DTTS'], alignment: HorizAlignment.Center},
        'PAYMENT_TYPE_NAME', 'PAYMENT_ID', 'PAYMENT_AMT', 'CREATED_BY', 'PAYMENT_NAME', 'STATUS_NAME'
    ],

    profileSearchProvider: PaymentSearchProviderPendingApproval,

    profileSortIdDefault: "",
    profileSorts: []
};

PaymentSearch.searchProfiles.push(PaymentSearchProfilePendingApproval)

PAEnvironment.registerBusinessObjectSearch("PaymentBO", "Payment", PaymentSearch, "Payment Search")

export {PaymentSearch}